import { useNotify as useUINotify, type Notification, NotificationBlock, IconSize } from '@keyvue/one-ui';

import IconCheck from '@keyvue/one-awesome-icons/icons/regular/circle-check.svg?component';
import IconClose from '@keyvue/one-awesome-icons/icons/regular/xmark.svg?component';

export default function useNotify() {
    const { notify: uiNotify } = useUINotify();

    const notify = (notification: Notification): () => void => {
        let result = uiNotify(notification);
        if (result === null) {
            result = () => {};
        }

        return result;
    };

    const notifySaving = (title?: string, duration: number = 3000) => notify({
        component: NotificationBlock,
        props: {
            color: 'orange-500',
            title: title ?? 'Bezig met opslaan...',
            text: 'Een moment geduld alstublieft',
        },
        duration,
    });

    const notifySaved = (title?: string, text?: string, duration: number = 2000) => notify({
        component: NotificationBlock,
        props: {
            color: 'green-500',
            title: title ?? 'Bevestiging',
            text: text ?? 'Het item is opgeslagen',
            icon: IconCheck,
            isCustomIcon: true,
            suffixIcon: IconClose,
            suffixIconSize: IconSize.sm,
            suffixIsCustomIcon: true,
        },
        duration,
    });

    const notifyDeleting = (title?: string, duration: number = 2000) => notify({
        component: NotificationBlock,
        props: {
            color: 'orange-500',
            title: title ?? 'Bezig met verwijderen...',
            text: 'Een moment geduld alstublieft',
            suffixIcon: IconClose,
            suffixIconSize: IconSize.sm,
            suffixIsCustomIcon: true,
        },
        duration,
    });

    const notifyDeleted = (title?: string, duration: number = 2000) => notify({
        component: NotificationBlock,
        props: {
            color: 'green-500',
            title: title ?? 'Het item is verwijderd',
            icon: IconCheck,
            isCustomIcon: true,
            suffixIcon: IconClose,
            suffixIconSize: IconSize.sm,
            suffixIsCustomIcon: true,
        },
        duration,
    });

    const notifyError = (error: any, duration: number = 2000) => notify({
        component: NotificationBlock,
        props: {
            color: 'red-500',
            title: 'Er is een fout opgetreden',
            text: error?.message ?? 'Onbekende fout',
            suffixIcon: IconClose,
            suffixIconSize: IconSize.sm,
            suffixIsCustomIcon: true,
        },
        duration,
    });

    return {
        notify,
        notifySaving,
        notifySaved,
        notifyDeleting,
        notifyDeleted,
        notifyError,
    };
}
